<template>
  <div class="ct-wrap container-fluid mt-4 px-4">
    <!-- ── Breadcrumb ─────────────────────────── -->
    <div class="breadcrumb text-md px-0 mb-2">
      <p>
        <span class="breadcrumb-item" @click="$router.push('/')">Inicio</span>
        &gt; Campañas
      </p>
    </div>

    <!-- ── Cabecera ────────────────────────────── -->
    <div class="ct-page-header mb-4">
      <div>
        <h5 class="ct-title">Campañas</h5>
        <p class="ct-subtitle">
          {{ canAdmin ? 'Vista de campañas del tipster seleccionado' : 'Resumen de tus campañas activas' }}
        </p>
      </div>

      <!-- Selector de tipster (solo admins) -->
      <div v-if="canAdmin" class="ct-tipster-selector">
        <label class="ct-label">Ver tipster</label>
        <div class="ct-selector-row">
          <select
            v-model="tipsterSeleccionado"
            class="ct-select ct-select--inline"
            @change="cargar"
          >
            <option value="">— Selecciona un tipster —</option>
            <option
              v-for="t in listaTipsters"
              :key="t.id"
              :value="t.id"
            >{{ t.nombre }}</option>
          </select>
          <button
            v-if="tipsterSeleccionado"
            class="ct-btn-reload"
            @click="cargar"
            title="Recargar"
          >
            <i class="fa fa-sync-alt"></i>
          </button>
        </div>
      </div>
    </div>

    <!-- ── Filtros de periodo ────────────────────── -->
    <div class="ct-periodo-bar mb-3">
      <button v-for="op in periodos" :key="op.val"
        class="ct-periodo-pill"
        :class="{ 'ct-periodo-pill--active': periodo === op.val }"
        @click="periodo = op.val"
      >{{ op.label }}</button>
    </div>

    <!-- ── Sin tipster seleccionado (admin) ──────── -->
    <div v-if="canAdmin && !tipsterSeleccionado" class="ct-state">
      <i class="fa fa-user-tie me-2 opacity-5"></i> Selecciona un tipster para ver sus campañas.
    </div>

    <!-- ── Cargando / error ────────────────────── -->
    <div v-else-if="cargando" class="ct-state">
      <i class="fa fa-spinner fa-spin me-2"></i> Cargando campañas…
    </div>
    <div v-else-if="error" class="ct-state ct-state--error">
      <i class="fa fa-exclamation-triangle me-2"></i> {{ error }}
    </div>

    <template v-else-if="!canAdmin || tipsterSeleccionado">
      <!-- ══════════════════════════════════════════════
           SECCIÓN 1 – MIS ENLACES (creados por el tipster)
      ══════════════════════════════════════════════ -->
      <div class="ct-section mb-5">
        <div class="ct-section-header">
          <div class="d-flex align-items-center gap-3">
            <span class="ct-section-title">Mis enlaces de seguimiento</span>
            <span class="ct-section-badge">{{ misEnlaces.length }}</span>
            <span class="ct-section-tag">Creados por ti · solo canales free</span>
          </div>
          <button class="ct-btn-crear" @click="abrirModal">
            <i class="fa fa-plus me-2"></i>Crear enlace
          </button>
        </div>

        <div v-if="misEnlaces.length === 0" class="ct-empty">
          <i class="fa fa-link me-2 opacity-5"></i>
          Todavía no has creado ningún enlace de seguimiento.
          <button class="ct-btn-crear-inline ms-3" @click="abrirModal">Crear ahora</button>
        </div>

        <template v-else>
          <!-- Buscador -->
          <div class="ct-filter-bar mb-2">
            <input
              v-model="busquedaMis"
              type="text"
              class="ct-input ct-input--sm"
              placeholder="Buscar enlace…"
            />
          </div>

          <div class="ct-table-wrap">
            <table class="ct-table">
              <thead>
                <tr>
                  <th @click="setSortMis('nombre')" class="ct-th--sortable">
                    Nombre {{ sortIconMis('nombre') }}
                  </th>
                  <th @click="setSortMis('canal_nombre')" class="ct-th--sortable">
                    Canal {{ sortIconMis('canal_nombre') }}
                  </th>
                  <th @click="setSortMis('entradas')" class="ct-th--sortable ct-th--num">
                    Entradas {{ sortIconMis('entradas') }}
                  </th>
                  <th @click="setSortMis('suscripciones')" class="ct-th--sortable ct-th--num">
                    En canal {{ sortIconMis('suscripciones') }}
                  </th>
                  <th @click="setSortMis('salidas')" class="ct-th--sortable ct-th--num">
                    Salidas {{ sortIconMis('salidas') }}
                  </th>
                  <th @click="setSortMis('pagos')" class="ct-th--sortable ct-th--num">
                    Pagos {{ sortIconMis('pagos') }}
                  </th>
                  <th @click="setSortMis('importe_eur')" class="ct-th--sortable ct-th--num">
                    Importe EUR {{ sortIconMis('importe_eur') }}
                  </th>
                  <th @click="setSortMis('importe_usd')" class="ct-th--sortable ct-th--num">
                    Importe USD {{ sortIconMis('importe_usd') }}
                  </th>
                  <th @click="setSortMis('created_at')" class="ct-th--sortable ct-th--num">
                    Creado {{ sortIconMis('created_at') }}
                  </th>
                  <th></th>
                </tr>
              </thead>
              <tbody>
                <tr v-if="rowsMis.length === 0">
                  <td colspan="10" class="ct-td-empty">Sin resultados</td>
                </tr>
                <tr v-for="c in rowsMisPage" :key="c.id">
                  <td>
                    <div class="ct-camp-nombre">{{ c.nombre }}</div>
                    <a
                      v-if="c.landing_slug"
                      href="#"
                      class="ct-enlace-link"
                      @click.prevent="abrirPreview(c)"
                    >
                      <i class="fa fa-eye me-1"></i>landing
                    </a>
                    <a
                      v-else-if="c.enlace"
                      :href="c.enlace"
                      target="_blank"
                      rel="noopener"
                      class="ct-enlace-link"
                    >
                      <i class="fa fa-link me-1"></i>enlace
                    </a>
                  </td>
                  <td class="ct-muted">{{ c.canal_nombre }}</td>
                  <td class="ct-num">{{ c.entradas }}</td>
                  <td class="ct-num">
                    <span class="ct-badge ct-badge--green">{{ c.suscripciones }}</span>
                    <button v-if="c.suscripciones > 0" class="ct-ojo" title="Ver quién está en el canal" @click="abrirDetalle(c, 'canal')"><i class="fa fa-eye"></i></button>
                  </td>
                  <td class="ct-num">
                    <span v-if="c.salidas" class="ct-badge ct-badge--red">{{ c.salidas }}</span>
                    <span v-else class="ct-muted">0</span>
                  </td>
                  <td class="ct-num">
                    {{ c.pagos }}
                    <button v-if="c.pagos > 0" class="ct-ojo" title="Ver compradores" @click="abrirDetalle(c, 'pagos')"><i class="fa fa-eye"></i></button>
                  </td>
                  <td class="ct-num v-cur--eur">
                    {{ c.importe_eur > 0 ? fmtEur(c.importe_eur) : '—' }}
                    <button v-if="c.importe_eur > 0" class="ct-ojo" title="Ver compras EUR" @click="abrirDetalle(c, 'pagos_eur', 'EUR')"><i class="fa fa-eye"></i></button>
                  </td>
                  <td class="ct-num v-cur--usd">
                    {{ c.importe_usd > 0 ? fmtUsd(c.importe_usd) : '—' }}
                    <button v-if="c.importe_usd > 0" class="ct-ojo" title="Ver compras USD" @click="abrirDetalle(c, 'pagos_usd', 'USD')"><i class="fa fa-eye"></i></button>
                  </td>
                  <td class="ct-num ct-muted">{{ fmtFecha(c.created_at) }}</td>
                  <td>
                    <button
                      class="ct-btn-borrar"
                      title="Eliminar enlace"
                      @click="confirmarBorrar(c)"
                    >
                      <i class="fa fa-trash"></i>
                    </button>
                  </td>
                </tr>
              </tbody>
            </table>
            <!-- paginación mis enlaces -->
            <div v-if="totalPagesMis > 1" class="ct-pag">
              <button class="ct-pag-btn" :disabled="pagMis <= 1" @click="setPagMis(pagMis - 1)">‹</button>
              <span class="ct-pag-info">{{ pagMis }} / {{ totalPagesMis }}</span>
              <button class="ct-pag-btn" :disabled="pagMis >= totalPagesMis" @click="setPagMis(pagMis + 1)">›</button>
            </div>
          </div>
        </template>
      </div>

      <!-- ══════════════════════════════════════════════
           SECCIÓN 2 – CAMPAÑAS DE PUBLICISTAS
      ══════════════════════════════════════════════ -->
      <div class="ct-section mb-5">
        <div class="ct-section-header">
          <span class="ct-section-title">Campañas de publicistas</span>
          <span class="ct-section-badge">{{ totalCampanasPublicista }}</span>
        </div>

        <div v-if="porPublicista.length === 0" class="ct-empty">
          <i class="fa fa-bullhorn me-2 opacity-5"></i>
          No hay campañas de publicistas aún.
        </div>

        <div v-for="grupo in porPublicista" :key="grupo.publicista_nombre" class="ct-grupo mb-4">
          <div class="ct-grupo-header">
            <i class="fa fa-user-tie me-2"></i>
            {{ grupo.publicista_nombre }}
            <span class="ct-grupo-count">{{ grupo.campanas.length }}</span>
          </div>

          <div class="ct-filter-bar mb-2">
            <input
              v-model="busqueda[grupo.publicista_nombre]"
              type="text"
              class="ct-input ct-input--sm"
              placeholder="Buscar campaña…"
            />
          </div>

          <div class="ct-table-wrap">
            <table class="ct-table">
              <thead>
                <tr>
                  <th @click="setSort(grupo.publicista_nombre, 'nombre')" class="ct-th--sortable">
                    Campaña {{ sortIcon(grupo.publicista_nombre, 'nombre') }}
                  </th>
                  <th @click="setSort(grupo.publicista_nombre, 'canal_nombre')" class="ct-th--sortable">
                    Canal {{ sortIcon(grupo.publicista_nombre, 'canal_nombre') }}
                  </th>
                  <th @click="setSort(grupo.publicista_nombre, 'entradas')" class="ct-th--sortable ct-th--num">
                    Entradas {{ sortIcon(grupo.publicista_nombre, 'entradas') }}
                  </th>
                  <th @click="setSort(grupo.publicista_nombre, 'suscripciones')" class="ct-th--sortable ct-th--num">
                    En canal {{ sortIcon(grupo.publicista_nombre, 'suscripciones') }}
                  </th>
                  <th @click="setSort(grupo.publicista_nombre, 'salidas')" class="ct-th--sortable ct-th--num">
                    Salidas {{ sortIcon(grupo.publicista_nombre, 'salidas') }}
                  </th>
                  <th @click="setSort(grupo.publicista_nombre, 'pagos')" class="ct-th--sortable ct-th--num">
                    Pagos {{ sortIcon(grupo.publicista_nombre, 'pagos') }}
                  </th>
                  <th @click="setSort(grupo.publicista_nombre, 'importe_eur')" class="ct-th--sortable ct-th--num">
                    Importe EUR {{ sortIcon(grupo.publicista_nombre, 'importe_eur') }}
                  </th>
                  <th @click="setSort(grupo.publicista_nombre, 'importe_usd')" class="ct-th--sortable ct-th--num">
                    Importe USD {{ sortIcon(grupo.publicista_nombre, 'importe_usd') }}
                  </th>
                  <th @click="setSort(grupo.publicista_nombre, 'created_at')" class="ct-th--sortable ct-th--num">
                    Creada {{ sortIcon(grupo.publicista_nombre, 'created_at') }}
                  </th>
                </tr>
              </thead>
              <tbody>
                <tr v-if="rowsPublicista(grupo).length === 0">
                  <td colspan="9" class="ct-td-empty">Sin resultados</td>
                </tr>
                <tr v-for="c in rowsPublicistaPage(grupo)" :key="c.id">
                  <td>
                    <div class="ct-camp-nombre">{{ c.nombre }}</div>
                    <a
                      v-if="c.landing_slug"
                      href="#"
                      class="ct-enlace-link"
                      @click.prevent="abrirPreview(c)"
                    >
                      <i class="fa fa-eye me-1"></i>landing
                    </a>
                    <a
                      v-else-if="c.enlace"
                      :href="c.enlace"
                      target="_blank"
                      rel="noopener"
                      class="ct-enlace-link"
                    >
                      <i class="fa fa-link me-1"></i>enlace
                    </a>
                  </td>
                  <td class="ct-muted">{{ c.canal_nombre }}</td>
                  <td class="ct-num">{{ c.entradas }}</td>
                  <td class="ct-num">
                    <span class="ct-badge ct-badge--green">{{ c.suscripciones }}</span>
                    <button v-if="c.suscripciones > 0" class="ct-ojo" title="Ver quién está en el canal" @click="abrirDetalle(c, 'canal')"><i class="fa fa-eye"></i></button>
                  </td>
                  <td class="ct-num">
                    <span v-if="c.salidas" class="ct-badge ct-badge--red">{{ c.salidas }}</span>
                    <span v-else class="ct-muted">0</span>
                  </td>
                  <td class="ct-num">
                    {{ c.pagos }}
                    <button v-if="c.pagos > 0" class="ct-ojo" title="Ver compradores" @click="abrirDetalle(c, 'pagos')"><i class="fa fa-eye"></i></button>
                  </td>
                  <td class="ct-num v-cur--eur">
                    {{ c.importe_eur > 0 ? fmtEur(c.importe_eur) : '—' }}
                    <button v-if="c.importe_eur > 0" class="ct-ojo" title="Ver compras EUR" @click="abrirDetalle(c, 'pagos_eur', 'EUR')"><i class="fa fa-eye"></i></button>
                  </td>
                  <td class="ct-num v-cur--usd">
                    {{ c.importe_usd > 0 ? fmtUsd(c.importe_usd) : '—' }}
                    <button v-if="c.importe_usd > 0" class="ct-ojo" title="Ver compras USD" @click="abrirDetalle(c, 'pagos_usd', 'USD')"><i class="fa fa-eye"></i></button>
                  </td>
                  <td class="ct-num ct-muted">{{ fmtFecha(c.created_at) }}</td>
                </tr>
              </tbody>
            </table>
            <!-- paginación publicista -->
            <div v-if="totalPagesPublicista(grupo) > 1" class="ct-pag">
              <button class="ct-pag-btn" :disabled="getPag(grupo) <= 1" @click="setPag(grupo, getPag(grupo) - 1)">‹</button>
              <span class="ct-pag-info">{{ getPag(grupo) }} / {{ totalPagesPublicista(grupo) }}</span>
              <button class="ct-pag-btn" :disabled="getPag(grupo) >= totalPagesPublicista(grupo)" @click="setPag(grupo, getPag(grupo) + 1)">›</button>
            </div>
          </div>
        </div>
      </div>
    </template>

    <!-- ══════════════════════════════════════════════
         MODAL – Crear enlace
    ══════════════════════════════════════════════ -->
    <transition name="ct-modal-fade">
      <div v-if="modal.visible" class="ct-modal-backdrop" @click.self="cerrarModal">
        <div class="ct-modal">
          <div class="ct-modal-header">
            <span class="ct-modal-title">
              <i class="fa fa-link me-2"></i>Crear enlace de seguimiento
            </span>
            <button class="ct-modal-close" @click="cerrarModal">
              <i class="fa fa-times"></i>
            </button>
          </div>
          <div class="ct-modal-body">
            <p class="ct-modal-desc">
              Crea un enlace de invitación único para tu canal free.<br>
              Úsalo en X, Facebook, Instagram o donde quieras — cada clic quedará registrado.
            </p>

            <div class="ct-form-group">
              <label class="ct-label">Canal free</label>
              <div v-if="modal.cargandoCanales" class="ct-muted">
                <i class="fa fa-spinner fa-spin me-1"></i> Cargando canales…
              </div>
              <select
                v-else
                v-model="modal.canal_id"
                class="ct-select"
              >
                <option value="">— Selecciona un canal —</option>
                <option
                  v-for="c in canalesFree"
                  :key="c.id"
                  :value="c.id"
                >{{ c.nombre }}</option>
              </select>
              <div v-if="canalesFree.length === 0 && !modal.cargandoCanales" class="ct-hint ct-hint--warn">
                No tienes canales free disponibles.
              </div>
            </div>

            <div class="ct-form-group">
              <label class="ct-label">Nombre de la campaña</label>
              <input
                v-model="modal.nombre"
                type="text"
                class="ct-input"
                placeholder="Ej: Instagram Stories Octubre"
                maxlength="100"
              />
              <div class="ct-hint">Un nombre descriptivo para identificarlo después.</div>
            </div>

            <div class="ct-form-group">
              <label class="ct-label">Ingreso automático al canal</label>
              <div class="ct-ingreso-auto-group">
                <label
                  class="ct-ingreso-auto-opt"
                  :class="{ 'ct-ingreso-auto-opt--active': modal.ingreso_auto === null }"
                >
                  <input type="radio" v-model="modal.ingreso_auto" :value="null" />
                  <span>Heredar config. del tipster</span>
                </label>
                <label
                  class="ct-ingreso-auto-opt"
                  :class="{ 'ct-ingreso-auto-opt--active': modal.ingreso_auto === true }"
                >
                  <input type="radio" v-model="modal.ingreso_auto" :value="true" />
                  <span>Siempre aceptar</span>
                </label>
                <label
                  class="ct-ingreso-auto-opt"
                  :class="{ 'ct-ingreso-auto-opt--active': modal.ingreso_auto === false }"
                >
                  <input type="radio" v-model="modal.ingreso_auto" :value="false" />
                  <span>Nunca aceptar</span>
                </label>
              </div>
              <div class="ct-hint">
                Controla si el bot aprueba automáticamente las solicitudes de unión para este enlace,
                independientemente de la configuración global del tipster.
              </div>
            </div>

            <div v-if="modal.error" class="ct-alert ct-alert--error">
              <i class="fa fa-exclamation-circle me-2"></i>{{ modal.error }}
            </div>
            <div v-if="modal.exito" class="ct-alert ct-alert--ok">
              <i class="fa fa-check-circle me-2"></i>Enlace creado correctamente.
            </div>
          </div>
          <div class="ct-modal-footer">
            <button class="ct-btn-sec" @click="cerrarModal" :disabled="modal.guardando">
              Cancelar
            </button>
            <button
              class="ct-btn-prim"
              @click="crearEnlace"
              :disabled="modal.guardando || !modal.canal_id || !modal.nombre.trim()"
            >
              <i v-if="modal.guardando" class="fa fa-spinner fa-spin me-2"></i>
              <i v-else class="fa fa-plus me-2"></i>
              Crear enlace
            </button>
          </div>
        </div>
      </div>
    </transition>

    <!-- ══════════════════════════════════════════════
         MODAL – Confirmar borrar
    ══════════════════════════════════════════════ -->
    <transition name="ct-modal-fade">
      <div v-if="borrar.visible" class="ct-modal-backdrop" @click.self="cerrarBorrar">
        <div class="ct-modal ct-modal--sm">
          <div class="ct-modal-header">
            <span class="ct-modal-title">
              <i class="fa fa-trash me-2 text-danger"></i>Eliminar enlace
            </span>
            <button class="ct-modal-close" @click="cerrarBorrar">
              <i class="fa fa-times"></i>
            </button>
          </div>
          <div class="ct-modal-body">
            <p>
              ¿Eliminar el enlace <strong class="ct-gold">{{ borrar.nombre }}</strong>?
              Esta acción no se puede deshacer.
            </p>
          </div>
          <div class="ct-modal-footer">
            <button class="ct-btn-sec" @click="cerrarBorrar" :disabled="borrar.cargando">
              Cancelar
            </button>
            <button class="ct-btn-danger" @click="ejecutarBorrar" :disabled="borrar.cargando">
              <i v-if="borrar.cargando" class="fa fa-spinner fa-spin me-2"></i>
              Eliminar
            </button>
          </div>
        </div>
      </div>
    </transition>

    <!-- ─────────────────────────────────────────────
         MODAL – Detalle (canal / pagos)
    ──────────────────────────────────────────────── -->
    <transition name="ct-modal-fade">
      <div v-if="detalle.activo" class="ct-modal-backdrop" @click.self="cerrarDetalle">
        <div class="ct-modal ct-modal--detalle">
          <div class="ct-modal-header">
            <span class="ct-modal-title"><i class="fa fa-eye me-2"></i>{{ detalle.titulo }}</span>
            <button class="ct-modal-close" @click="cerrarDetalle">✕</button>
          </div>
          <div class="ct-modal-body ct-detalle-body">
            <!-- Cargando -->
            <div v-if="detalle.cargando" class="ct-detalle-loading">
              <i class="fa fa-spinner fa-spin me-2"></i>Cargando...
            </div>
            <!-- Error -->
            <div v-else-if="detalle.error" class="ct-detalle-empty">{{ detalle.error }}</div>
            <!-- Sin datos -->
            <div v-else-if="detalle.filas.length === 0" class="ct-detalle-empty">Sin registros.</div>
            <!-- Canal: nick + email + fecha -->
            <template v-else-if="detalle.tipo === 'canal'">
              <table class="ct-detalle-table">
                <thead><tr>
                  <th>Nick / Usuario</th>
                  <th class="ct-th--num">Entrada</th>
                </tr></thead>
                <tbody>
                  <tr v-for="(f, i) in detalle.filas" :key="i">
                    <td>{{ f.nick || '—' }}</td>
                    <td class="ct-num ct-muted">{{ fmtFecha(f.fecha_entrada) }}</td>
                  </tr>
                </tbody>
              </table>
            </template>
            <!-- Pagos: usuario + producto + monto + fecha -->
            <template v-else>
              <table class="ct-detalle-table">
                <thead><tr>
                  <th>Comprador</th>
                  <th>Servicio</th>
                  <th class="ct-th--num">Importe</th>
                  <th class="ct-th--num">Fecha</th>
                </tr></thead>
                <tbody>
                  <tr v-for="(f, i) in detalle.filas" :key="i">
                    <td>
                      <div>{{ f.user_nombre || '—' }}</div>
                      <div class="ct-muted" style="font-size:.75rem">{{ f.user_email }}</div>
                    </td>
                    <td class="ct-muted">{{ f.producto }}</td>
                    <td class="ct-num" :class="f.moneda === 'USD' ? 'v-cur--usd' : 'v-cur--eur'">
                      {{ f.moneda === 'USD' ? fmtUsd(f.precio) : fmtEur(f.precio) }}
                    </td>
                    <td class="ct-num ct-muted">{{ fmtFecha(f.fecha) }}</td>
                  </tr>
                </tbody>
              </table>
            </template>
          </div>
        </div>
      </div>
    </transition>

    <!-- ─────────────────────────────────────────────
         MODAL – Vista previa landing
    ──────────────────────────────────────────────── -->
    <transition name="fade">
      <div v-if="preview.activo" class="ct-modal-backdrop" @click.self="cerrarPreview">
        <div class="ct-preview-box">
          <div class="ct-preview-header">
            <span class="ct-preview-title"><i class="fa fa-mobile-alt me-1"></i>{{ preview.nombre }}</span>
            <div class="d-flex align-items-center gap-2">
              <a :href="preview.url" target="_blank" rel="noopener" class="ct-preview-ext" title="Abrir en pestaña nueva">
                <i class="fa fa-external-link-alt"></i>
              </a>
              <button class="ct-preview-close" @click="cerrarPreview">✕</button>
            </div>
          </div>
          <div class="ct-preview-phone">
            <div v-if="preview.cargando" class="ct-preview-loading">
              <i class="fa fa-spinner fa-spin"></i>
            </div>
            <iframe
              v-else
              :srcdoc="preview.html"
              class="ct-preview-iframe"
              sandbox="allow-scripts allow-same-origin allow-forms"
              scrolling="yes"
              title="Vista previa landing"
            ></iframe>
          </div>
        </div>
      </div>
    </transition>
  </div>
</template>

<script>
import tipsterCampanasService from "@/services/tipsterCampanas.service";

export default {
  name: "CampanasTipster",

  data() {
    return {
      cargando:    false,
      error:       null,
      porPublicista: [],
      misEnlaces:    [],
      canalesFree:   [],

      // selector admin
      tipsterSeleccionado: '',
      listaTipsters:       [],

      // ordenamiento por grupo (publicistas)
      sortState: {},   // { [grupoNombre]: { col, dir } }
      busqueda:  {},   // { [grupoNombre]: string }

      // ordenamiento mis enlaces
      sortMis:     { col: 'nombre', dir: 'asc' },
      busquedaMis: '',

      // paginación
      pagState: {},  // { [grupoNombre]: page }
      pagMis:   1,

      // filtro de periodo
      periodo: 'todo',

      modal: {
        visible:        false,
        cargandoCanales: false,
        canal_id:       '',
        nombre:         '',
        ingreso_auto:   null,
        guardando:      false,
        error:          null,
        exito:          false,
      },

      borrar: {
        visible:  false,
        id:       null,
        nombre:   '',
        cargando: false,
      },
      preview: {
        activo:   false,
        html:     '',
        url:      '',
        nombre:   '',
        cargando: false,
      },

      detalle: {
        activo:   false,
        titulo:   '',
        tipo:     '',   // canal | pagos
        filas:    [],
        cargando: false,
        error:    null,
      },
    };
  },

  computed: {
    rolEfectivo() {
      return Number(this.$store.getters['auth/rolEfectivo'] ?? 0);
    },
    canAdmin() {
      // superadmin (1) y admintipster (2) pueden elegir tipster
      return [1, 2].includes(this.rolEfectivo);
    },

    periodos() {
      return [
        { val: 'mes',  label: 'Mes actual' },
        { val: '3m',   label: '3 meses'    },
        { val: '6m',   label: '6 meses'    },
        { val: 'anio', label: 'Año actual' },
        { val: 'todo', label: 'Todo'       },
      ];
    },

    totalCampanasPublicista() {
      return this.porPublicista.reduce((s, g) => s + g.campanas.length, 0);
    },

    rowsMis() {
      let list = [...this.misEnlaces];
      const q = (this.busquedaMis || '').toLowerCase();
      if (q) {
        list = list.filter(
          (c) =>
            c.nombre.toLowerCase().includes(q) ||
            c.canal_nombre.toLowerCase().includes(q)
        );
      }
      const { col, dir } = this.sortMis;
      list.sort((a, b) => {
        const va = a[col] ?? '';
        const vb = b[col] ?? '';
        if (va < vb) return dir === 'asc' ? -1 : 1;
        if (va > vb) return dir === 'asc' ? 1 : -1;
        return 0;
      });
      return list;
    },

    rowsMisPage() {
      const start = (this.pagMis - 1) * 15;
      return this.rowsMis.slice(start, start + 15);
    },

    totalPagesMis() {
      return Math.ceil(this.rowsMis.length / 15) || 1;
    },
  },

  watch: {
    tipsterSeleccionado(val) {
      try {
        if (val) sessionStorage.setItem('ct_tipster_id', String(val));
        else sessionStorage.removeItem('ct_tipster_id');
      } catch (e) { /* storage bloqueado */ }
    },

    busqueda: {
      deep: true,
      handler(newVal) {
        // reset página del grupo cuya búsqueda cambió
        const reset = {};
        Object.keys(newVal).forEach((k) => { reset[k] = 1; });
        this.pagState = { ...this.pagState, ...reset };
      },
    },

    busquedaMis() {
      this.pagMis = 1;
    },

    periodo() {
      this.cargar();
    },

    // El rol llega tarde en el refresh — cuando está disponible arrancamos
    rolEfectivo(val) {
      if ([1, 2].includes(val) && this.listaTipsters.length === 0) {
        this.iniciarAdmin();
      } else if (val === 4 && !this.cargando && this.porPublicista.length === 0 && this.misEnlaces.length === 0) {
        this.cargar();
      }
    },
  },

  async mounted() {
    // Si el rol ya está disponible (navegación interna), arrancamos directo
    if (this.rolEfectivo !== 0) {
      if (this.canAdmin) {
        await this.iniciarAdmin();
      } else {
        await this.cargar();
      }
    }
    // Si rolEfectivo === 0 todavía, el watcher se encarga cuando llegue
  },

  methods: {
    async iniciarAdmin() {
      try {
        const saved = sessionStorage.getItem('ct_tipster_id');
        if (saved) this.tipsterSeleccionado = parseInt(saved, 10) || '';
      } catch (e) { /* storage bloqueado */ }

      await this.cargarListaTipsters();
      if (this.tipsterSeleccionado) await this.cargar();
    },

    async cargarListaTipsters() {
      try {
        const resp = await this.$store.dispatch("auth/listaTipsters");
        this.listaTipsters = Array.isArray(resp) ? resp : (resp?.data || []);
      } catch (e) {
        this.listaTipsters = [];
      }
    },

    async cargar() {
      if (this.canAdmin && !this.tipsterSeleccionado) return;
      this.cargando = true;
      this.error    = null;
      // reset paginación al recargar
      this.pagState = {};
      this.pagMis   = 1;
      try {
        const tid  = this.canAdmin ? this.tipsterSeleccionado : null;
        const data = await tipsterCampanasService.listar(tid || null, this.periodo);
        this.porPublicista = data.por_publicista || [];
        this.misEnlaces    = data.mis_enlaces    || [];
      } catch (e) {
        this.error = "Error al cargar las campañas. Inténtalo de nuevo.";
      } finally {
        this.cargando = false;
      }
    },

    // ── Ordenamiento por grupo ──────────────────
    sortKey(grupo) {
      return this.sortState[grupo] || { col: 'nombre', dir: 'asc' };
    },

    setSort(grupo, col) {
      const curr = this.sortKey(grupo);
      const dir  = curr.col === col && curr.dir === 'asc' ? 'desc' : 'asc';
      this.sortState = { ...this.sortState, [grupo]: { col, dir } };
    },

    sortIcon(grupo, col) {
      const s = this.sortKey(grupo);
      if (s.col !== col) return '↕';
      return s.dir === 'asc' ? '↑' : '↓';
    },

    rowsPublicista(grupo) {
      const q = ((this.busqueda[grupo.publicista_nombre] || '')).toLowerCase();
      let list = [...grupo.campanas];
      if (q) {
        list = list.filter(
          (c) =>
            c.nombre.toLowerCase().includes(q) ||
            c.canal_nombre.toLowerCase().includes(q)
        );
      }
      const { col, dir } = this.sortKey(grupo.publicista_nombre);
      list.sort((a, b) => {
        const va = a[col] ?? '';
        const vb = b[col] ?? '';
        if (va < vb) return dir === 'asc' ? -1 : 1;
        if (va > vb) return dir === 'asc' ? 1 : -1;
        return 0;
      });
      return list;
    },

    rowsPublicistaPage(grupo) {
      const all   = this.rowsPublicista(grupo);
      const page  = this.getPag(grupo);
      const start = (page - 1) * 15;
      return all.slice(start, start + 15);
    },

    totalPagesPublicista(grupo) {
      return Math.ceil(this.rowsPublicista(grupo).length / 15) || 1;
    },

    getPag(grupo) {
      return this.pagState[grupo.publicista_nombre] || 1;
    },

    setPag(grupo, page) {
      const p = Math.max(1, Math.min(page, this.totalPagesPublicista(grupo)));
      this.pagState = { ...this.pagState, [grupo.publicista_nombre]: p };
    },

    setPagMis(page) {
      this.pagMis = Math.max(1, Math.min(page, this.totalPagesMis));
    },

    // ── Ordenamiento mis enlaces ────────────────
    setSortMis(col) {
      if (this.sortMis.col === col) {
        this.sortMis = { col, dir: this.sortMis.dir === 'asc' ? 'desc' : 'asc' };
      } else {
        this.sortMis = { col, dir: 'asc' };
      }
    },

    sortIconMis(col) {
      if (this.sortMis.col !== col) return '↕';
      return this.sortMis.dir === 'asc' ? '↑' : '↓';
    },

    // ── Modal crear ─────────────────────────────
    async abrirModal() {
      this.modal = {
        visible:         true,
        cargandoCanales: true,
        canal_id:        '',
        nombre:          '',
        ingreso_auto:    null,
        guardando:       false,
        error:           null,
        exito:           false,
      };
      try {
        const tid = this.canAdmin ? (this.tipsterSeleccionado || null) : null;
        this.canalesFree = await this.$store.dispatch("auth/tipsterCampanasCanalesFree", tid);
      } catch (e) {
        this.canalesFree = [];
      } finally {
        this.modal.cargandoCanales = false;
      }
    },

    cerrarModal() {
      if (this.modal.guardando) return;
      this.modal.visible = false;
    },

    async crearEnlace() {
      this.modal.error   = null;
      this.modal.exito   = false;
      this.modal.guardando = true;
      try {
        const payload = {
          canal_id:     this.modal.canal_id,
          nombre:       this.modal.nombre.trim(),
          ingreso_auto: this.modal.ingreso_auto,
          ...(this.canAdmin && this.tipsterSeleccionado ? { tipster_id: this.tipsterSeleccionado } : {}),
        };
        const resp = await this.$store.dispatch("auth/tipsterCampanasCrearEnlace", payload);
        if (resp.res === 'OK') {
          this.modal.exito = true;
          await this.cargar();
          setTimeout(() => {
            this.modal.visible = false;
          }, 1200);
        } else {
          this.modal.error = resp.mensaje || 'Error al crear el enlace.';
        }
      } catch (e) {
        this.modal.error = e?.response?.data?.mensaje || 'Error de conexión.';
      } finally {
        this.modal.guardando = false;
      }
    },

    // ── Modal borrar ────────────────────────────
    confirmarBorrar(campana) {
      this.borrar = { visible: true, id: campana.id, nombre: campana.nombre, cargando: false };
    },

    cerrarBorrar() {
      if (this.borrar.cargando) return;
      this.borrar.visible = false;
    },

    async ejecutarBorrar() {
      this.borrar.cargando = true;
      try {
        const tid = this.canAdmin ? (this.tipsterSeleccionado || null) : null;
        await this.$store.dispatch("auth/tipsterCampanasBorrarEnlace", { id: this.borrar.id, tipsterId: tid });
        this.borrar.visible = false;
        await this.cargar();
      } catch (e) {
        /* silencioso: recargar igualmente */
        await this.cargar();
        this.borrar.visible = false;
      }
    },

    // ── Formato ─────────────────────────────────
    landingUrl(slug) {
      return (process.env.VUE_APP_API_BASE_URL || '') + '/l/' + slug;
    },

    async abrirPreview(campana) {
      const tipsterId = this.canAdmin ? (this.tipsterSeleccionado || null) : null;
      this.preview = { activo: true, html: '', url: this.landingUrl(campana.landing_slug), nombre: campana.nombre, cargando: true };
      try {
        const html = await tipsterCampanasService.landingPreview(campana.landing_slug, tipsterId);
        this.preview.html     = html;
        this.preview.cargando = false;
      } catch {
        this.preview.html     = '<p style="color:#f66;padding:20px">No se pudo cargar la vista previa.</p>';
        this.preview.cargando = false;
      }
    },

    cerrarPreview() {
      this.preview = { activo: false, html: '', url: '', nombre: '', cargando: false };
    },

    async abrirDetalle(campana, tipo, moneda = null) {
      const titulos = {
        canal:     `En canal — ${campana.nombre}`,
        pagos_eur: `Compras EUR — ${campana.nombre}`,
        pagos_usd: `Compras USD — ${campana.nombre}`,
        pagos:     `Compras — ${campana.nombre}`,
      };
      this.detalle = { activo: true, titulo: titulos[tipo] || campana.nombre, tipo, filas: [], cargando: true, error: null };
      const tipsterId = this.canAdmin ? (this.tipsterSeleccionado || null) : null;
      const tipoApi   = tipo === 'canal' ? 'canal' : 'pagos';
      try {
        const filas = await tipsterCampanasService.detalle(campana.id, tipoApi, moneda, tipsterId);
        this.detalle.filas    = filas;
        this.detalle.cargando = false;
      } catch {
        this.detalle.error    = 'No se pudieron cargar los datos.';
        this.detalle.cargando = false;
      }
    },

    cerrarDetalle() {
      this.detalle.activo = false;
    },

    fmtEur(v) {
      return new Intl.NumberFormat('es-ES', { style: 'currency', currency: 'EUR' }).format(v);
    },

    fmtUsd(v) {
      return new Intl.NumberFormat('en-US', { style: 'currency', currency: 'USD' }).format(v);
    },

    fmtFecha(v) {
      if (!v) return '—';
      const d = new Date(v);
      return d.toLocaleDateString('es-ES', { day: '2-digit', month: '2-digit', year: 'numeric' });
    },
  },
};
</script>

<style scoped>
/* ── Base ──────────────────────────────────────────── */
.ct-wrap {
  color: var(--q-text, #e0e6ef);
  min-height: 60vh;
}

/* ── Cabecera ──────────────────────────────────────── */
.ct-page-header {
  display: flex;
  align-items: flex-end;
  justify-content: space-between;
  gap: 1rem;
  border-bottom: 1px solid var(--q-border, #1e2a3a);
  padding-bottom: 1rem;
}
.ct-title {
  color: var(--q-gold, #d4af37);
  font-size: 1.25rem;
  font-weight: 700;
  margin: 0;
  letter-spacing: .03em;
}
.ct-subtitle {
  color: var(--q-muted, #6b7a8d);
  font-size: .82rem;
  margin: .2rem 0 0;
}

/* ── Estados globales ──────────────────────────────── */
.ct-state {
  text-align: center;
  padding: 3rem 1rem;
  color: var(--q-muted, #6b7a8d);
  font-size: .9rem;
}
.ct-state--error { color: #ef5350; }

/* ── Secciones ─────────────────────────────────────── */
.ct-section-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: .75rem;
  margin-bottom: .75rem;
}
.ct-section-title {
  font-size: .95rem;
  font-weight: 600;
  color: var(--q-gold, #d4af37);
  text-transform: uppercase;
  letter-spacing: .06em;
}
.ct-section-badge {
  background: var(--q-gold, #d4af37);
  color: #060a10;
  font-size: .7rem;
  font-weight: 700;
  padding: .15rem .5rem;
  border-radius: 20px;
}
.ct-section-tag {
  font-size: .73rem;
  color: var(--q-muted, #6b7a8d);
  background: var(--q-card, #0d1520);
  border: 1px solid var(--q-border, #1e2a3a);
  border-radius: 4px;
  padding: .15rem .5rem;
}

/* ── Grupos (por publicista) ───────────────────────── */
.ct-grupo-header {
  font-size: .82rem;
  font-weight: 600;
  color: var(--q-gold, #d4af37);
  background: var(--q-card, #0d1520);
  border: 1px solid var(--q-border, #1e2a3a);
  border-radius: 6px 6px 0 0;
  padding: .5rem .9rem;
  display: flex;
  align-items: center;
  gap: .4rem;
}
.ct-grupo-count {
  background: #1a2840;
  color: var(--q-muted, #6b7a8d);
  font-size: .68rem;
  padding: .1rem .4rem;
  border-radius: 20px;
}

/* ── Empty ─────────────────────────────────────────── */
.ct-empty {
  color: var(--q-muted, #6b7a8d);
  background: var(--q-card, #0d1520);
  border: 1px dashed var(--q-border, #1e2a3a);
  border-radius: 6px;
  padding: 2rem 1.5rem;
  text-align: center;
  font-size: .85rem;
}

/* ── Filtro ────────────────────────────────────────── */
.ct-filter-bar {
  display: flex;
  gap: .75rem;
  align-items: center;
}
.ct-input {
  background: var(--q-card, #0d1520);
  border: 1px solid var(--q-border-md, #2a3a52);
  border-radius: 5px;
  color: var(--q-text, #e0e6ef);
  padding: .45rem .75rem;
  font-size: .85rem;
  outline: none;
  transition: border-color .15s;
  width: 100%;
  max-width: 320px;
}
.ct-input--sm { padding: .3rem .6rem; font-size: .8rem; }
.ct-input:focus { border-color: var(--q-gold, #d4af37); }

/* ── Tabla ─────────────────────────────────────────── */
.ct-table-wrap {
  overflow-x: auto;
  border: 1px solid var(--q-border, #1e2a3a);
  border-radius: 0 0 6px 6px;
}
.ct-grupo .ct-table-wrap { border-top: none; }
.ct-section > .ct-table-wrap { border-radius: 6px; }
.ct-table {
  width: 100%;
  border-collapse: collapse;
  font-size: .82rem;
}
.ct-table thead th {
  background: #0a1220;
  color: var(--q-muted, #6b7a8d);
  font-weight: 600;
  font-size: .72rem;
  text-transform: uppercase;
  letter-spacing: .05em;
  padding: .55rem .8rem;
  border-bottom: 1px solid var(--q-border, #1e2a3a);
  white-space: nowrap;
  user-select: none;
}
.ct-th--sortable { cursor: pointer; }
.ct-th--sortable:hover { color: var(--q-text, #e0e6ef); }
.ct-th--num { text-align: right; }
.ct-table tbody tr {
  border-bottom: 1px solid var(--q-border, #1e2a3a);
  transition: background .1s;
}
.ct-table tbody tr:last-child { border-bottom: none; }
.ct-table tbody tr:hover { background: rgba(255,255,255,.03); }
.ct-table tbody td {
  padding: .55rem .8rem;
  vertical-align: middle;
}
.ct-td-empty {
  text-align: center;
  color: var(--q-muted, #6b7a8d);
  padding: 1.5rem !important;
  font-size: .8rem;
}

/* ── Valores ───────────────────────────────────────── */
.ct-muted { color: var(--q-muted, #6b7a8d); font-size: .8rem; }
.ct-num { text-align: right; font-variant-numeric: tabular-nums; }
.ct-camp-nombre { font-weight: 500; margin-bottom: .15rem; }
.ct-enlace-link {
  font-size: .72rem;
  color: #4ba3f5;
  text-decoration: none;
  opacity: .7;
}
.ct-enlace-link:hover { opacity: 1; text-decoration: underline; }

/* EUR / USD colores del proyecto */
.v-cur--eur { color: var(--q-gold, #d4af37); }
.v-cur--usd { color: #26c6da; }

/* ── Badges ────────────────────────────────────────── */
.ct-badge {
  font-size: .72rem;
  font-weight: 600;
  padding: .15rem .45rem;
  border-radius: 20px;
  display: inline-block;
}
.ct-badge--green { background: rgba(38,198,132,.15); color: #26c684; }
.ct-badge--red   { background: rgba(239,83,80,.12);  color: #ef5350; }

/* ── Selector tipster (admin) ──────────────────────── */
.ct-tipster-selector {
  display: flex;
  flex-direction: column;
  gap: .3rem;
  min-width: 260px;
}
.ct-selector-row {
  display: flex;
  align-items: center;
  gap: .5rem;
}
.ct-select--inline {
  flex: 1;
}
.ct-btn-reload {
  background: transparent;
  border: 1px solid var(--q-border-md, #2a3a52);
  color: var(--q-muted, #6b7a8d);
  border-radius: 5px;
  padding: .45rem .65rem;
  font-size: .8rem;
  cursor: pointer;
  transition: border-color .15s, color .15s;
  flex-shrink: 0;
}
.ct-btn-reload:hover { border-color: var(--q-gold, #d4af37); color: var(--q-gold, #d4af37); }

/* ── Botones ───────────────────────────────────────── */
.ct-btn-crear {
  background: var(--q-gold, #d4af37);
  color: #060a10;
  border: none;
  border-radius: 5px;
  padding: .45rem 1rem;
  font-size: .82rem;
  font-weight: 600;
  cursor: pointer;
  transition: opacity .15s;
  white-space: nowrap;
}
.ct-btn-crear:hover { opacity: .85; }
.ct-btn-crear-inline {
  background: transparent;
  color: var(--q-gold, #d4af37);
  border: 1px solid var(--q-gold, #d4af37);
  border-radius: 4px;
  padding: .3rem .75rem;
  font-size: .78rem;
  cursor: pointer;
  transition: background .15s;
}
.ct-btn-crear-inline:hover { background: rgba(212,175,55,.1); }
.ct-btn-borrar {
  background: transparent;
  color: #ef5350;
  border: 1px solid rgba(239,83,80,.3);
  border-radius: 4px;
  padding: .25rem .5rem;
  font-size: .75rem;
  cursor: pointer;
  transition: border-color .15s, background .15s;
}
.ct-btn-borrar:hover { background: rgba(239,83,80,.1); border-color: #ef5350; }

/* ── Gold highlight ────────────────────────────────── */
.ct-gold { color: var(--q-gold, #d4af37); }

/* ═══════════════════════════════════════════════════
   MODAL
═══════════════════════════════════════════════════ */
.ct-modal-backdrop {
  position: fixed;
  inset: 0;
  background: rgba(0,0,0,.6);
  backdrop-filter: blur(2px);
  z-index: 2000;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 1rem;
}
.ct-modal {
  background: var(--q-card, #0d1520);
  border: 1px solid var(--q-border-md, #2a3a52);
  border-radius: 8px;
  width: 100%;
  max-width: 500px;
  box-shadow: 0 20px 60px rgba(0,0,0,.5);
}
.ct-modal--sm { max-width: 380px; }
.ct-modal-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 1rem 1.25rem .75rem;
  border-bottom: 1px solid var(--q-border, #1e2a3a);
}
.ct-modal-title {
  font-weight: 600;
  font-size: .9rem;
  color: var(--q-gold, #d4af37);
}
.ct-modal-close {
  background: none;
  border: none;
  color: var(--q-muted, #6b7a8d);
  font-size: .9rem;
  cursor: pointer;
  padding: .2rem .4rem;
  line-height: 1;
  border-radius: 4px;
  transition: color .15s;
}
.ct-modal-close:hover { color: var(--q-text, #e0e6ef); }
.ct-modal-body { padding: 1.25rem; }
.ct-modal-desc {
  font-size: .82rem;
  color: var(--q-muted, #6b7a8d);
  margin-bottom: 1.25rem;
  line-height: 1.5;
}
.ct-modal-footer {
  display: flex;
  justify-content: flex-end;
  gap: .75rem;
  padding: .75rem 1.25rem 1rem;
  border-top: 1px solid var(--q-border, #1e2a3a);
}

/* ── Formulario modal ──────────────────────────────── */
.ct-form-group { margin-bottom: 1rem; }
.ct-label {
  display: block;
  font-size: .78rem;
  font-weight: 600;
  color: var(--q-muted, #6b7a8d);
  margin-bottom: .4rem;
  text-transform: uppercase;
  letter-spacing: .04em;
}
.ct-select {
  width: 100%;
  background: var(--q-bg, #070b12);
  border: 1px solid var(--q-border-md, #2a3a52);
  border-radius: 5px;
  color: var(--q-text, #e0e6ef);
  padding: .45rem .75rem;
  font-size: .85rem;
  outline: none;
  transition: border-color .15s;
}
.ct-select:focus { border-color: var(--q-gold, #d4af37); }
.ct-hint {
  font-size: .73rem;
  color: var(--q-muted, #6b7a8d);
  margin-top: .3rem;
}
.ct-hint--warn { color: #ffb74d; }
.ct-input { width: 100%; }

/* ── Ingreso automático radio group ────────────────── */
.ct-ingreso-auto-group {
  display: flex;
  gap: .5rem;
  flex-wrap: wrap;
  margin-top: .25rem;
}
.ct-ingreso-auto-opt {
  display: flex;
  align-items: center;
  gap: .4rem;
  padding: .35rem .75rem;
  border: 1px solid var(--q-border, #2a3040);
  border-radius: 6px;
  cursor: pointer;
  font-size: .82rem;
  color: var(--q-muted, #6b7a8d);
  transition: border-color .15s, color .15s;
  user-select: none;
}
.ct-ingreso-auto-opt input[type="radio"] { display: none; }
.ct-ingreso-auto-opt--active {
  border-color: var(--q-gold, #d4af37);
  color: var(--q-gold, #d4af37);
}

/* ── Alertas modal ─────────────────────────────────── */
.ct-alert {
  font-size: .82rem;
  padding: .6rem .9rem;
  border-radius: 5px;
  margin-top: .75rem;
}
.ct-alert--error { background: rgba(239,83,80,.12); color: #ef5350; border: 1px solid rgba(239,83,80,.3); }
.ct-alert--ok    { background: rgba(38,198,132,.1);  color: #26c684; border: 1px solid rgba(38,198,132,.2); }

/* ── Botones modal ─────────────────────────────────── */
.ct-btn-prim {
  background: var(--q-gold, #d4af37);
  color: #060a10;
  border: none;
  border-radius: 5px;
  padding: .5rem 1.25rem;
  font-size: .82rem;
  font-weight: 600;
  cursor: pointer;
  transition: opacity .15s;
}
.ct-btn-prim:disabled { opacity: .45; cursor: not-allowed; }
.ct-btn-prim:not(:disabled):hover { opacity: .85; }
.ct-btn-sec {
  background: transparent;
  color: var(--q-muted, #6b7a8d);
  border: 1px solid var(--q-border-md, #2a3a52);
  border-radius: 5px;
  padding: .5rem 1.1rem;
  font-size: .82rem;
  cursor: pointer;
  transition: border-color .15s, color .15s;
}
.ct-btn-sec:hover { border-color: var(--q-text, #e0e6ef); color: var(--q-text, #e0e6ef); }
.ct-btn-sec:disabled { opacity: .45; cursor: not-allowed; }
.ct-btn-danger {
  background: #ef5350;
  color: #fff;
  border: none;
  border-radius: 5px;
  padding: .5rem 1.25rem;
  font-size: .82rem;
  font-weight: 600;
  cursor: pointer;
  transition: opacity .15s;
}
.ct-btn-danger:disabled { opacity: .45; cursor: not-allowed; }
.ct-btn-danger:not(:disabled):hover { opacity: .85; }

/* ── Transición modal ──────────────────────────────── */
.ct-modal-fade-enter-active,
.ct-modal-fade-leave-active { transition: opacity .2s ease; }
.ct-modal-fade-enter-from,
.ct-modal-fade-leave-to { opacity: 0; }

/* ══════════════════════════════════════════════════════
   MODAL PREVIEW LANDING
══════════════════════════════════════════════════════ */
.ct-preview-box {
  background: var(--q-card, #0e141f);
  border: 1px solid var(--q-border, #1e2d3a);
  border-radius: 14px;
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 16px 20px 20px;
  gap: 14px;
  max-height: 96vh;
}
.ct-preview-header {
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: space-between;
}
.ct-preview-title {
  font-size: .85rem;
  font-weight: 700;
  color: var(--q-text, #e0e6ef);
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  max-width: 260px;
}
.ct-preview-ext {
  color: var(--q-muted, #6b7a8d);
  font-size: .85rem;
  padding: 2px 6px;
  border-radius: 4px;
  transition: color .15s;
  text-decoration: none;
}
.ct-preview-ext:hover { color: var(--q-gold, #d4af37); }
.ct-preview-close {
  background: transparent;
  border: none;
  color: var(--q-muted, #6b7a8d);
  font-size: 1rem;
  cursor: pointer;
  padding: 2px 8px;
  border-radius: 4px;
  line-height: 1;
}
.ct-preview-close:hover { color: #ef5350; }
.ct-preview-phone {
  width: 375px;
  height: 650px;
  border: 3px solid var(--q-border-md, #2a3d50);
  border-radius: 16px;
  overflow: hidden;
  position: relative;
  background: #000;
  box-shadow: 0 0 40px rgba(0,0,0,.6);
  flex-shrink: 0;
}
.ct-preview-loading {
  position: absolute;
  inset: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 1.5rem;
  color: var(--q-muted, #6b7a8d);
}
.ct-preview-iframe {
  width: 100%;
  height: 100%;
  border: none;
  display: block;
}

/* ── Botón ojo ─────────────────────────────────────── */
.ct-ojo {
  background: none;
  border: none;
  color: var(--q-muted, #6b7a8d);
  font-size: .7rem;
  cursor: pointer;
  padding: 0 0 0 4px;
  line-height: 1;
  vertical-align: middle;
  opacity: .7;
  transition: color .15s, opacity .15s;
}
.ct-ojo:hover { color: var(--q-gold, #d4af37); opacity: 1; }

/* ── Modal detalle ──────────────────────────────────── */
.ct-modal--detalle { max-width: 660px; }
.ct-detalle-body { padding: .75rem 1.25rem 1.25rem; max-height: 60vh; overflow-y: auto; }
.ct-detalle-loading,
.ct-detalle-empty {
  text-align: center;
  padding: 2rem;
  color: var(--q-muted, #6b7a8d);
  font-size: .875rem;
}
.ct-detalle-table {
  width: 100%;
  border-collapse: collapse;
  font-size: .8rem;
}
.ct-detalle-table th {
  color: var(--q-muted, #6b7a8d);
  font-weight: 600;
  font-size: .7rem;
  text-transform: uppercase;
  letter-spacing: .04em;
  padding: .35rem .5rem;
  border-bottom: 1px solid var(--q-border, #1e2a3a);
  text-align: left;
}
.ct-detalle-table td {
  padding: .45rem .5rem;
  border-bottom: 1px solid var(--q-border, #1e2a3a);
  color: var(--q-text, #e0e6ef);
  vertical-align: middle;
}
.ct-detalle-table tr:last-child td { border-bottom: none; }
.ct-detalle-table tr:hover td { background: rgba(255,255,255,.03); }

/* ── Paginación ────────────────────────────────────── */
.ct-pag {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: .5rem;
  padding: .6rem 0 .25rem;
}
.ct-pag-btn {
  background: var(--q-card, #0d1520);
  border: 1px solid var(--q-border-md, #2a3a52);
  color: var(--q-muted, #6b7a8d);
  border-radius: 5px;
  padding: .2rem .7rem;
  font-size: .85rem;
  cursor: pointer;
  transition: color .15s, border-color .15s;
  line-height: 1.4;
}
.ct-pag-btn:hover:not(:disabled) {
  color: var(--q-gold, #d4af37);
  border-color: var(--q-gold, #d4af37);
}
.ct-pag-btn:disabled { opacity: .35; cursor: default; }
.ct-pag-info {
  font-size: .8rem;
  color: var(--q-muted, #6b7a8d);
  min-width: 48px;
  text-align: center;
}

/* ── Filtros de periodo ─────────────────────────────── */
.ct-periodo-bar {
  display: flex;
  flex-wrap: wrap;
  gap: .4rem;
}
.ct-periodo-pill {
  padding: .25rem .75rem;
  border-radius: 20px;
  border: 1px solid var(--q-border, #2a3040);
  background: transparent;
  color: var(--q-muted, #6b7a8d);
  font-size: .8rem;
  cursor: pointer;
  transition: all .15s;
}
.ct-periodo-pill:hover {
  border-color: var(--q-gold, #d4af37);
  color: var(--q-gold, #d4af37);
}
.ct-periodo-pill--active {
  background: var(--q-gold, #d4af37);
  border-color: var(--q-gold, #d4af37);
  color: #0a0c10;
  font-weight: 600;
}

/* ── Responsive ────────────────────────────────────── */

/* Tablet: 768px */
@media (max-width: 768px) {
  .ct-page-header {
    flex-direction: column;
    align-items: flex-start;
    gap: .75rem;
  }
  .ct-tipster-selector {
    width: 100%;
    min-width: unset;
  }
  .ct-periodo-pill {
    font-size: .75rem;
    padding: .2rem .6rem;
  }
  .ct-modal--detalle { max-width: 98vw; }
}

/* Móvil: 600px */
@media (max-width: 600px) {
  /* Layout */
  .ct-wrap { padding-left: .75rem !important; padding-right: .75rem !important; }

  /* Header de sección: título + botón en columna */
  .ct-section-header {
    flex-direction: column;
    align-items: flex-start;
    gap: .5rem;
  }
  .ct-section-header > .d-flex { flex-wrap: wrap; gap: .4rem; }
  .ct-section-tag { display: none; } /* ocupa demasiado espacio */
  .ct-btn-crear { width: 100%; text-align: center; }

  /* Input buscador */
  .ct-input { max-width: 100%; }

  /* Periodo pills */
  .ct-periodo-bar { gap: .25rem; }
  .ct-periodo-pill { font-size: .72rem; padding: .18rem .55rem; }

  /* Modal – bottom sheet */
  .ct-modal-backdrop {
    align-items: flex-end;
    padding: 0;
  }
  .ct-modal {
    max-width: 100%;
    width: 100%;
    border-radius: 14px 14px 0 0;
    max-height: 90vh;
    overflow-y: auto;
  }
  .ct-modal--detalle { max-width: 100%; }

  /* Footer del modal: botones apilados */
  .ct-modal-footer {
    flex-direction: column-reverse;
    gap: .5rem;
  }
  .ct-modal-footer > button,
  .ct-modal-footer > .ct-btn-prim,
  .ct-modal-footer > .ct-btn-sec,
  .ct-modal-footer > .ct-btn-danger { width: 100%; text-align: center; }

  /* Preview phone */
  .ct-preview-box { padding: 10px 8px 12px; max-height: 100dvh; }
  .ct-preview-phone { width: min(320px, 88vw); height: 560px; }
}
</style>
